import { useState } from "react";
import { toast } from "sonner";
import { MaskLines } from "../components/Motion";
import { api, errorText } from "../lib/api";

const SUBJECTS = ["Editorial enquiry", "Subscriptions & billing", "Advertising & partnerships", "Permissions & reprints", "Other"];

export default function Contact() {
  const [f, setF] = useState({ name: "", email: "", subject: SUBJECTS[0], message: "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { await api.post("/contact", f); toast.success("Message sent. We reply within two working days."); setF({ ...f, message: "" }); }
    catch (err) { toast.error(errorText(err)); }
    setBusy(false);
  };
  return (
    <div className="px-5 lg:px-12 pt-14 grid lg:grid-cols-12 gap-14" data-testid="contact-page">
      <div className="lg:col-span-5">
        <p className="eyebrow mb-6">Contact</p>
        <h1 className="f-serif text-5xl sm:text-6xl tracking-tight leading-[0.95]"><MaskLines lines={["Write to", <em key="e" className="font-light">the editors.</em>]} /></h1>
        <dl className="mt-12 space-y-5 text-[var(--ink-2)]">
          <div className="border-t rule pt-4"><dt className="eyebrow">Editorial office</dt><dd className="mt-1">[editorial email placeholder]</dd></div>
          <div className="border-t rule pt-4"><dt className="eyebrow">Address</dt><dd className="mt-1">[office address placeholder]</dd></div>
        </dl>
      </div>
      <form onSubmit={submit} className="lg:col-span-6 lg:col-start-7 space-y-8" data-testid="contact-form">
        <div className="grid sm:grid-cols-2 gap-8">
          <label><span className="eyebrow">Name *</span><input required value={f.name} onChange={set("name")} className="field" data-testid="contact-name-input" /></label>
          <label><span className="eyebrow">Email *</span><input required type="email" value={f.email} onChange={set("email")} className="field" data-testid="contact-email-input" /></label>
        </div>
        <label className="block"><span className="eyebrow">Subject</span><select value={f.subject} onChange={set("subject")} className="field" data-testid="contact-subject-select">{SUBJECTS.map((s) => <option key={s}>{s}</option>)}</select></label>
        <label className="block"><span className="eyebrow">Message *</span><textarea required rows={6} value={f.message} onChange={set("message")} className="field resize-none" data-testid="contact-message-input" /></label>
        <button disabled={busy} className="btn-ink h-12 px-10 font-semibold disabled:opacity-50" data-testid="contact-submit-btn">{busy ? "Sending…" : "Send message"}</button>
      </form>
    </div>
  );
}
